import React, { useState } from 'react';
import { ToastType, useToast } from 'services/toast';
import { downloadFileFromUrl } from 'core/services/storage/utils';
import { AnchorText } from 'components/Text';
import { Typography } from '@mui/material';
import { useGetMediaDownloadUrlLazyQuery } from 'generated-graphql/hooks/apollo-hooks';

type Props = {
  fileName: string;
  messageId: string;
};

const MediaDownload: React.FC<Props> = ({ messageId, fileName }) => {
  const { showToast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const [getMediaDownloadUrl] = useGetMediaDownloadUrlLazyQuery();

  const handleDownload = async () => {
    try {
      setIsLoading(true);
      const { data } = await getMediaDownloadUrl({
        variables: {
          messageId
        }
      });

      const downloadUrl = data?.getMediaDownloadUrl?.url as string;
      downloadFileFromUrl(downloadUrl, fileName);
    } catch (e) {
      showToast({
        message: 'Download error. Try again or contact support.',
        type: ToastType.Error
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Typography variant="body2">Downloading</Typography>;
  }

  return <AnchorText onClick={handleDownload}>Download</AnchorText>;
};

export { MediaDownload };
